export const DELETE_SUCCESS = 'Скидка удалена';
export const DELETE_ERROR = 'Не удалось удалить скидку';
